import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

// Shared guest-passenger form constants. Mirrors the mobile guest passenger form
// (app-customer src/components/guest-passenger-form/GuestPassengerFormFields.tsx).
// Consumed by AddEditGuestModal and the client booking PassengerPanel ("Who is this booking for?").
export const TITLE_OPTIONS = ["Mr.", "Mrs.", "Ms.", "Miss", "Dr.", "Prof.", "Sir."];

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const passengerContactSchema = z.object({
  title: z.string().min(1, "Title not selected"),
  firstName: z.string().trim().min(1, "First Name is required"),
  lastName: z.string().trim().min(1, "Last Name is required"),
  email: z.string().min(1, "Email is required").regex(EMAIL_PATTERN, "Invalid email address"),
  contactNumber: z
    .string()
    .min(1, "Please fill out a phone number")
    .refine((value) => isValidPhoneNumber(value ?? ""), "Invalid phone number"),
});
